/**
 * OWA-978: a Payrix refund is its own transaction. A payment's processorPaymentMeta describes the
 * CHARGE (its amount, date, and in `refunded` every refund so far), which Payment History and the
 * refund and payout paths read. When the server answers a payment refresh with a refund (so the card
 * can show the refund's status), it carries the charge as `originalCharge` (server twin:
 * server/src/payments/payrix/refundCharge.ts).
 */
import {ETransactionType, PayrixTransaction, PayrixTransactionFull} from '@/@types/payrix';

type WithCharge = (PayrixTransaction | PayrixTransactionFull) & {originalCharge?: PayrixTransactionFull};

/** True for a card or eCheck refund. */
export function isRefundTxn(txn: Pick<PayrixTransaction, 'type'> | null | undefined): boolean {
    const type = Number(txn?.type);
    return type === ETransactionType.CreditCardRefund || type === ETransactionType.ECheckRefund;
}

/**
 * The Payrix charge to store as a payment's metadata: the refresh answer's `originalCharge`, else
 * the answer itself. Null when only a refund is known, so the stored charge is kept rather than
 * replaced by a refund.
 */
export function chargeToStore(txn: WithCharge | null | undefined): PayrixTransactionFull | null {
    const charge = txn?.originalCharge ?? txn;
    return charge && !isRefundTxn(charge) ? charge as PayrixTransactionFull : null;
}
